import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="header">
          <h1 className="title">RGB Fabrication</h1>
          <p className="description">My name is Christian Reed. I've been a web developer for over a decade, specializing in front-end development, with an emphasis on design systems for large sites, semantic markup, mobile responsive, and accessibility.</p>
          <p className="description">I've primarily worked at startups, but most recently worked at a major provider of corporate intranets and external facing support sites for Fortune 500 companies.</p>
          <p className="description">If you're a design-concious company, and need to leverage design across a large footprint in a maintainable way, I can help you with that.</p>
          <p className="description">I'm based in Seattle Washington, but am available for remote engagements, and can travel as necessary.</p>
        </header>
        <section className="section more">
          <h2 className="title">More</h2>
          <ul className="links">
            <li className="link-item"><a className="link" href="https://www.linkedin.com/in/chrstnrd/">LinkedIn</a></li>
            <li className="link-item"><a className="link" href="https://github.com/christianreed">GitHub</a></li>
            <li className="link-item"><a className="link" href="https://blog.rgbfab.com">Blog</a></li>
          </ul>
        </section>
        <section className="section contact">
          <h2 className="title">Contact</h2>
          <ul className="links">
            <li className="link-item"><a className="link" href="mailto:christian@rgbfab.com">christian@rgbfab.com</a></li>
          </ul>
        </section>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js